import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { hasViewAppointmentPermission } from '../../permission-utils/appointment';
import SurveyMenu from './SurveyMenu';
import RadiologyMenu from './RadiologyMenu';
import SupportMenu from './SupportMenu';
import { canViewReports, checkHOD, checkHOU } from '../../permission-utils/settings';

const FrontDeskMenu = () => {
	const staff = useSelector(state => state.user.profile);
	const [isSupervisor, setIsSuperVisor] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			const isHOD = await checkHOD();
			const isHOU = await checkHOU();

			if (isHOD || isHOU) {
				setIsSuperVisor(true);
			}
		};

		fetchData();
	}, []);

	return (
		<>
			{isSupervisor && (
				<li>
					<Link to="/front-desk/overview">
						<div className="icon-w">
							<div className="os-icon os-icon-cv-2" />
						</div>
						<span>Overview</span>
					</Link>
				</li>
			)}
			{hasViewAppointmentPermission(staff.permissions) && (
				<li>
					<Link to="/front-desk/appointments/queue">
						<div className="icon-w">
							<div className="os-icon os-icon-calendar-time" />
						</div>
						<span>Appointments</span>
					</Link>
				</li>
			)}
			{staff.details.department.slug === 'call-center' || staff.username === 'p.akoh' ? (
				<li>
					<Link to="/doctor/bookings/pending">
						<div className="icon-w">
							<div className="icon-feather-home" />
						</div>
						<span>Bookings</span>
					</Link>
				</li>
			) : null}
			<li>
				<Link to="/front-desk/patients">
					<div className="icon-w">
						<div className="os-icon os-icon-cv-2" />
					</div>
					<span>All Patients</span>
				</Link>
			</li>

			<li>
				<Link to="/front-desk/admitted">
					<div className="icon-w">
						<div className="icon-feather-folder-plus" />
					</div>
					<span>Admitted Patients</span>
				</Link>
			</li>
			<li>
				<Link to="/front-desk/opd-patients">
					<div className="icon-w">
						<div className="icon-feather-folder-plus" />
					</div>
					<span>UNREG Patients</span>
				</Link>
			</li>
			<li>
				<Link to="/front-desk/proforma-invoice">
					<div className="icon-w">
						<div className="os-icon os-icon-newspaper" />
					</div>
					<span>Proforma Invoice</span>
				</Link>
			</li>
			<li>
				<Link to="/front-desk/services">
					<div className="icon-w">
						<div className="os-icon os-icon-cv-2" />
					</div>
					<span>Services / Price List</span>
				</Link>
			</li>
			<li>
				<Link to="/front-desk/immunizations">
					<div className="icon-w">
						<div className="os-icon os-icon-plus-circle" />
					</div>
					<span>Immunizations</span>
				</Link>
			</li>
			{staff.role.slug === 'front-desk' && (
				<li>
					<Link to="/procedure/all-request">
						<div className="icon-w">
							<div className="os-icon os-icon-newspaper" />
						</div>
						<span>Procedure Requests</span>
					</Link>
				</li>
			)}
			{isSupervisor && (
				<li>
					<Link to="/report/frontdesk/registration">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Reports</span>
					</Link>
				</li>
			)}
			{
				// TEMP: also let it-admin see the Support/Patient Chat link, not just call-center
				// front-desk staff - remove the it-admin OR once no longer needed.
				((staff.role.slug === 'front-desk' && staff.details.department.slug === 'call-center') || staff.role.slug === 'it-admin') && (
					<>
						<li className="sub-header">
							<span>Support</span>
						</li>
						<SupportMenu />
					</>
				)
			}
			<li className="sub-header">
				<span>SURVEYS</span>
			</li>
			<SurveyMenu />
			{staff.role.slug === 'front-desk' && (
				<li className="sub-header">
					<span>RADIOLOGY</span>
				</li>
			)}
			{staff.role.slug === 'front-desk' && <RadiologyMenu />}
		</>
	);
};

export default FrontDeskMenu;
